import { sendRequest } from 'best-modules/vue-utils'

type Entity = 'document' | 'task' | 'incident'

export type AttachmentCredentials = {
  name: string
  path: string
  size: number
  uploadedBy?: number
}

const attachmentList = (entity: Entity, entityId: number): Promise<any> => {
  return sendRequest({
    name: 'attachmentList',
    method: 'get',
    url: `/json/${entity}/${entityId}/attachments`,
  })
}

const attachmentCreate = (
  entity: Entity,
  entityId: number,
  credentials: AttachmentCredentials
): Promise<any> => {
  return sendRequest({
    name: 'attachmentCreate',
    method: 'post',
    url: `/json/${entity}/${entityId}/attachment`,
    payload: credentials,
  })
}

const attachmentDelete = (
  entity: Entity,
  entityId: number,
  attachmentId: number
): Promise<any> => {
  return sendRequest({
    name: 'attachmentDelete',
    method: 'delete',
    url: `/json/${entity}/${entityId}/attachment/${attachmentId}`,
  })
}

export { attachmentList, attachmentCreate, attachmentDelete }
